// Intentional global API consumed by other theme scripts (custom.js, accordion.js, pageanchor.js).
// eslint-disable-next-line unicorn/no-global-object-property-assignment
window.caleffiGlobalUtils = Object.freeze({
  setupFocusTrap: (containerElement, togglerElement = null) => {
    let _focusableElems = [];
    let _lastFocusableElement = null;
    let _isTrapActive = false;

    const _initFocusableElements = () => {
      _focusableElems
        = containerElement?.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled])',
        ) || [];
      _focusableElems = Array.from(_focusableElems).filter(
        (element) => window.getComputedStyle(element).display !== 'none',
      );

      _lastFocusableElement = _focusableElems.at(-1);
    };

    const _keydownHandler = (event) => {
      if (event.key !== 'Tab') {
        return;
      }

      if (event.shiftKey) {
        if (togglerElement && document.activeElement === _focusableElems[0]) {
          event.preventDefault();
          togglerElement.focus();
        } else if (
          [_focusableElems[0], togglerElement].includes(document.activeElement)
        ) {
          event.preventDefault();
          _lastFocusableElement.focus();
        }
      } else if (
        document.activeElement
        && document.activeElement === togglerElement
      ) {
        event.preventDefault();
        _focusableElems[0].focus();
      } else if (document.activeElement === _lastFocusableElement) {
        const focusableTarget = togglerElement || _focusableElems[0];

        event.preventDefault();
        focusableTarget.focus();
      }
    };

    const enableFocusTrap = () => {
      _initFocusableElements();

      if (!_isTrapActive && _focusableElems.length) {
        _isTrapActive = true;

        containerElement.addEventListener('keydown', _keydownHandler);
        togglerElement?.addEventListener('keydown', _keydownHandler);
      }
    };

    const disableFocusTrap = () => {
      if (!(_isTrapActive && _focusableElems.length)) {
        return;
      }

      _isTrapActive = false;

      containerElement.removeEventListener('keydown', _keydownHandler);
      togglerElement?.removeEventListener('keydown', _keydownHandler);
      togglerElement?.focus();
    };

    return {
      enableFocusTrap,
      disableFocusTrap,
      toggleFocusTrap: () => {
        if (_isTrapActive) {
          disableFocusTrap();
        } else {
          enableFocusTrap();
        }
      },
      isTrapActive: () => _isTrapActive,
    };
  },
});
